import {
  Avatar,
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Stack,
  styled,
  Typography,
} from "@mui/material"
import MuiAppBar from "@mui/material/AppBar"
import Toolbar from "@mui/material/Toolbar"
import { FC, useState } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router"
import { selectProfile } from "src/features/profile"
import mblsLogo from "../../assets/mobilus-logo.png"

import { appConstants } from "../appConstants"
import { useAppSelector } from "../hooks/hooks"
import { Profile } from "./Profile"

const StyledAppBar = styled(MuiAppBar)(({ theme }) => ({
  backgroundColor: "transparent",
  height: appConstants.mainAppBarHeight,
}))

export const MainAppbar: FC = () => {
  const profile = useAppSelector(selectProfile)
  const [drawerOpen, setDrawerOpen] = useState(false)
  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return
      }
      setDrawerOpen(open)
    }

  return (
    <>
      <StyledAppBar
        color={"textPrimary" as any}
        position="fixed"
        variant={"outlined"}
        elevation={0}
      >
        <Toolbar>
          <Box
            component="img"
            sx={{ height: 32, width: 120 }}
            alt="Mobilus"
            src={mblsLogo}
          />
          <AppbarLinks />
          <Stack
            direction={"row"}
            justifyContent={"flex-end"}
            marginLeft={"auto"}
            alignItems={"center"}
          >
            <Typography variant="h6">{profile?.hauler?.name}</Typography>
            <Stack
              marginLeft={1}
              direction={"row"}
              spacing={1.5}
              alignItems={"center"}
            >
              {/* <Campaign /> */}
              {/* <Help /> */}
              <Avatar
                alt="User"
                sx={{ bgcolor: "primary.main", cursor: "pointer" }}
                onClick={toggleDrawer(true)}
              >
                {profile?.user?.firstName?.[0]?.toUpperCase()}
                {profile?.user?.lastName?.[0]?.toUpperCase()}
              </Avatar>
            </Stack>
          </Stack>
        </Toolbar>
      </StyledAppBar>
      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box
          sx={{ width: appConstants.userDrawerWidth }}
          p={2}
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <Profile />
        </Box>
      </Drawer>
    </>
  )
}

const AppbarLinks: FC = () => {
  const { t } = useTranslation()
  return (
    <List
      sx={{
        display: "flex",
        marginLeft: 2,
      }}
    >
      {appBarLinks.map((item, index) => {
        return (
          <ListItemButton
            color="green"
            key={index}
            component={Link}
            to={item.path}
          >
            <ListItemText
              sx={{
                "& .MuiTypography-root": {
                  fontWeight: 500,
                  letterSpacing: 1.5,
                },
              }}
              primary={t(item.sectionKey)}
            />
          </ListItemButton>
        )
      })}
    </List>
  )
}

const appBarLinks = [
  {
    path: `/`,
    sectionKey: "orders",
  },
  {
    path: `/dashboard`,
    sectionKey: "dashboard",
  },
  {
    path: `/customers`,
    sectionKey: "customers",
  },
  {
    path: `/reports`,
    sectionKey: "reports",
  },
  {
    path: `/lockers`,
    sectionKey: "lockers",
  },
] as Array<{ path: string; sectionKey: string }>
